import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import { EtlService } from 'src/app/user/vault-data-migration-etl/etl.service';



export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;

} 

interface MappingTestbedComponentinfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Component({
    selector: 'app-customtest-bed',
    templateUrl: './customtest-bed.component.html',
    styleUrls: ['./customtest-bed.component.scss'],
    standalone: false
})



export class CustomtestBedComponent implements OnInit {

  descriptionText: string = '';
  backgroundColorButton: string;
  dropdownSelected: boolean = true;
  selectedFileName
  description: string = '';

  selectedFileNames: any = [];
  newFiles: File[] = [];

  files
  validFolder
  uploadedFolderName


  rowSelection
  rowSelectionForTablesFields

  columnDefsForSelectedFields
  columnDefsForObjects

  
  gridmgrnAPI
  gridmgAPII
  temprunHistory
  gridmgrnData
  list
  setid:string = "";
  currentmigration:string = "";
  isClicked = false;
  Buttonname = "create"
  defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true
  };

  mappingtestbedid = 0;
  isVisible = false
  clickTimeout: any; 
  

  
  
  


  currentPage: number = 0;
  pageSize: number = 8;  // 4 rows × 2 columns

  constructor(
    public dialogref: MatDialogRef<CustomtestBedComponent>,
    private localStorageSettings: LocalStorageSettingsService,
    private snackbar: MatSnackBar,
    private migrationconfigservices: MigrationConfigComponentServices,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,
    private spinner:NgxUiLoaderService,
    private service:EtlService
    
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    if(this.data != null){
      this.mappingtestbedid = this.data.edata.mappingtestbedid;
      this.currentmigration = this.data.edata.migrationid;
      this.setid = this.data.edata.setid;
      this.description = this.data.edata.remarks;
      this.Buttonname = "Update"
      this.isVisible = true

    }
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.rowSelection = 'multiple';
    this.rowSelectionForTablesFields = 'single';
    this.columnDefsForObjects = [
      {
  headerName: "Migration Runs",
  headerTooltip: "Migration Runs",
  tooltipValueGetter: params => "Migration Runs : " + (params.data?.activity || '') + ' - ' + (params.data?.comment || ''),
  valueGetter: params => (params.data?.migrationId || '') + ' - ' + (params.data?.comment || ''),
  filter: "agTextColumnFilter",
  width: 310,
  headerCheckboxSelectionFilteredOnly: true,
  checkboxSelection: false,
  animateRows: true,
}

    ];


    this.columnDefsForSelectedFields = [
      {
        headerName: "Extraction Sets",
        headerTooltip: "Extraction Sets",
        tooltipValueGetter: params => "Extraction Sets : " + params.value,
        field: "setid",
        filter: "agTextColumnFilter",
        width: 310,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: false,
        cellStyle: { " padding-left": "5px" }
      }
    ];
  }

  onFileSelected(event: Event): void {
    console.log(event);
    const input = event.target as HTMLInputElement;
    console.log(input);
    if (!input.files) return;

    const allowedExtensions = ['.csv'];

    // Filter only .csv files
    this.newFiles = Array.from(input.files).filter(file => {
        const fileName = file.name.toLowerCase();
        return allowedExtensions.some(ext => fileName.endsWith(ext));
    });

    if (this.newFiles.length === 0) {
        console.error('No valid CSV files selected.');
        this.snackbar.open("No valid CSV files selected", "OK", { duration: 5000 });
        return;
    }

    this.selectedFileNames = this.newFiles.map(file => file.name);
    console.log('Selected files:', this.selectedFileNames);
}




  updateData(): void {
    let request
    console.log(this.newFiles.length)
    console.log(this.currentmigration)
    if(this.description === "" || this.description === undefined){
      this.snackbar.open("Please Enter Description", "OK", { duration: 5000 });
      return;
    }
    if(this.currentmigration != "" && this.setid === ""){
      console.log(this.setid)
      this.snackbar.open("Please Select Extraction Setid", "OK", { duration: 5000 });
      return;
    }
    if(this.newFiles.length === 0 &&  this.currentmigration === "" ) {
      this.snackbar.open("Please select extraction sets from Migration ID or upload external files for creation of test bed", "OK", { duration: 5000 });
      return;
    }else{
      if(this.currentmigration === ""){
        if(confirm("Are you sure you want to procced with External Files") != true){
          return
        }
      }
      if(this.data != null && this.selectedFileNames.length > 0){
        if(confirm("Are you sure you want to override existing Extraction Files") != true){
          return
        }
      }
      
      console.log(this.newFiles)
      
      // Example: Simulate uploading files
       const formData = new FormData();
      this.newFiles.forEach(file => {
      if (this.selectedFileNames.some(name => file.name.includes(name))) {
        formData.append('files', file, file.name);
        console.log(file.name);
      }
      });

     if(this.currentmigration === ""){
      request = {
        migrationid : null,
        setid : null,
        remarks : this.description,
        tenantid : this.localStorageSettings.getSettings("dnsName"),
        createdBy : this.localStorageSettings.getSettings("AuthUsername")
      }
     }
     else{
      request = {
        migrationid : this.currentmigration,
        setid : this.setid,
        remarks : this.description,
        tenantid : this.localStorageSettings.getSettings("dnsName"),
        mappingtestbedid : this.mappingtestbedid,
        createdBy : this.localStorageSettings.getSettings("AuthUsername")
      }
    }
    
    this.spinner.start();
    if(this.selectedFileNames.length > 0){
    this.migrationconfigservices.uploadfile(formData).subscribe((res) => {
      console.log(res)
      this.migrationconfigservices.MappingtestbedInsertRcord(request).subscribe((res) => { 
      this.snackbar.open(res.data, "OK", { duration: 5000 });
      this.dialogref.close();
      this.spinner.stop();
    });
    });
    }else{
      this.migrationconfigservices.MappingtestbedInsertRcord(request).subscribe((res) => { 
      this.snackbar.open(res.data, "OK", { duration: 5000 });
      this.dialogref.close();
      this.spinner.stop();
    });

    }
  }  
}

  close(): void {
    this.dialogref.close();
  }

  // Empty stubs (if needed in future)
  onCheckboxChange(): void {}
  mappingFiletoS3(event: any, filetype: string): void {}




  onFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.files = Array.from(input.files);
      
      // Check for valid file types
      const allowedExtensions = ['.csv'];
      const allFilesValid = this.files.every(file => {
        const extension = file.name.slice((file.name.lastIndexOf(".")));
        return allowedExtensions.includes(extension.toLowerCase());
      });
  
      this.validFolder = this.files.length > 0 && allFilesValid;
  
      if (!this.validFolder) {
        const invalidFiles = this.files.filter(file => {
          const extension = file.name.slice((file.name.lastIndexOf(".")));
          return !allowedExtensions.includes(extension.toLowerCase());
        });
  
        // Clear the files array
        this.files = [];
  
        this.snackbar.open(`The file "${invalidFiles[0].name}" is not a valid type. Please upload files with one of the following extensions:  .csv`, "OK", { duration: 5000 });
      }
      if (this.files.length > 0) {
        const firstFile = this.files[0];
        const folderPath = firstFile.webkitRelativePath.split('/');
        this.uploadedFolderName = folderPath[0]; 
    }
      
      // Reset the file input to allow re-uploading the same files
      input.value = '';
    }
  }


 


  
  
  onGridReadyForSelectedTableFields(params){
    this.gridmgAPII = params.api
    this.gridmgAPII.setGridOption('rowData', []);
  }

   // Add this at class level

cellClickedObjects(event: any): void {

  if (this.clickTimeout) {
    clearTimeout(this.clickTimeout);  // Cancel previous click waiting period
    this.clickTimeout = null;
    return; // Don't handle the second click (double click)
  }

  this.clickTimeout = setTimeout(() => {
    this.clickTimeout = null;

    // Your original single-click logic here
    this.isClicked = true;
    console.log(event);
    this.list = [];
    this.currentmigration = event.value.split('-')[0].trim();
    console.log(this.currentmigration);

    this.service.retriveSetDetails(this.localStorageSettings.getSettings("dnsName"), this.currentmigration, "ETL").subscribe((val) => {
      console.log(val);
      const uniqueSet = new Set();

      for (let i = 0; i < val.length; i++) {
        const item = val[i];
        const uniqueKey = item.setid;
        if (item.activity === 'Extraction' && item.state === 'Completed' && !uniqueSet.has(uniqueKey)) {
          uniqueSet.add(uniqueKey);
          this.list.push(item);
        }
      }

      console.log(this.list);
      this.gridmgAPII.setGridOption('rowData', []);
      this.gridmgAPII.setGridOption('rowData', this.list);
    });

  }, 250);  // Wait 250ms to confirm it's not a double-click
}

  onRowSelectedToRemove(event){
    console.log(event)
    this.setid = event.value
    console.log(this.setid)

  }

  


  

  onGridReadyForObjects(params) {
    
    this.gridmgrnAPI = params.api;
    this.temprunHistory = params;
    this.list = [];
  
    this.gridmgrnAPI.setGridOption('rowData', []); // reset data once
    if(this.data == null){
    this.spinner.start();
  
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName"))
      .subscribe((val) => {
        
        console.log(val)
        this.gridmgrnData = val;
  
        if (this.gridmgrnData.length === 0) {
          this.gridmgrnAPI.setGridOption('rowData', []);
        } else {
                  
          console.log(this.gridmgrnData)
          this.gridmgrnAPI.setGridOption('rowData', this.gridmgrnData);
        }
  
        this.spinner.stop(); // stop after data is loaded
      });
    }
  }
  

  



















get paginatedFileNames(): string[] {
  const start = this.currentPage * this.pageSize;
  return this.selectedFileNames.slice(start, start + this.pageSize);
}

nextPage(): void {
  if ((this.currentPage + 1) * this.pageSize < this.selectedFileNames.length) {
    this.currentPage++;
  }
}

previousPage(): void {
  if (this.currentPage > 0) {
    this.currentPage--;
  }
}

removeFile(index: number): void {
  this.selectedFileNames.splice(index, 1);
  
  // Recalculate if you're on the last page and it became empty
  if (this.currentPage > 0 && this.paginatedFileNames.length === 0) {
    this.currentPage--;
  }
}

pagedFileNames() {
  const start = this.currentPage * this.pageSize;
  return this.selectedFileNames.slice(start, start + this.pageSize);
}

 get RuntotalPages(): number {
  return Math.ceil(this.selectedFileNames.length / this.pageSize) || 1;
}

  
}
